import axios from 'axios';
import { API_URL } from '../api/base';

// Create axios instance for admin API
export const adminApi = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add auth token
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');

      // Redirect to login using replace to force page reload
      window.location.replace('/admin/login');
    }
    return Promise.reject(error);
  }
);

export default adminApi;
